<template><div/></template>
<script>

export default {
  name: 'UnitMarker',
  props: {
    google:{default:null},
    map:{default:null},
    uid:{default:null},
    coords:{default:null},
    gps:{default:false},
    speed:{default:false},
  },
  data() {
    return {
      coord: null,
      marker: new this.google.maps.Marker({
        position: this.getGPS() || { lat: 0, lng: 0 },
        map: this.map,
        icon: this.getIcon(),
        visible: this.getVisible(),
        zIndex: this.getZIndex(),
      }),
    }
  },
  computed: {
    unit() { return this.getUnit() },
    cgps() { return this.getGPS() || { lat: 0, lng: 0 } },
    visible() { return this.getVisible() },
    zIndex() { return this.getZIndex() },
    color() { return this.getColor() },
  },
  created() { this.updateCoord() },
  methods: {
    getUnit() { return this.$store.state.units[this.uid] },
    getGPS() {
      if (this.gps !== false)
        return this.gps
      let unit = this.getUnit()
      if (unit && unit.gps.length)
        return { lat: unit.gps[0].lat, lng: unit.gps[0].lon }
      else
        return null
    },
    getSpeed() {
      if (this.speed !== false)
        return this.speed
      let u = this.getUnit()
      return u.speed
    },
    getColor() {
      let u = this.getUnit()
      if (!u) return '#aaa' // Placeholder: not visible with no unit.
      return (this.gps === false
        ? this.$store.getters.unitStatus(u).color         // Unit color.
        : this.$store.getters.unit_fleet[u.id].unit_color // Fleet unit online color.
      )
    },
    getVisible() {
      if (!this.getGPS()) return false
      return this.$store.getters.is_uid_visible(this.uid)
    },
    getZIndex() {
      let unit = this.getUnit()
      return (unit && this.uid === this.$store.state.selectedUnit) ? 101 : 100
    },
    
    getStrokeColor() {
      return this.$store.state.selectedUnit !== this.uid ? '#fff' : '#f00'
    },
    getIcon() {
      let unit = this.getUnit()
      if (!unit) {
        return {
          path: this.google.maps.SymbolPath.CIRCLE,
        }
      }
      let rv = {
        fillColor: this.getColor(),
        fillOpacity: 1.0,
        strokeColor: this.getStrokeColor(),
        strokeWeight: 2,
      }
      let speed = this.getSpeed()
      if (!speed || speed.length < 2 || speed[0] < 0.25) {
        rv.path = this.google.maps.SymbolPath.CIRCLE
        rv.scale = 10
      } else {
        rv.path = this.google.maps.SymbolPath.FORWARD_CLOSED_ARROW
        rv.scale = 5
        rv.rotation = speed[1]
      } 
      return rv
    },
    updateIcon() {
      this.marker.setIcon(this.getIcon())
    },
    updateCoord() {
      if (this.visible) {
        if (this.coord) {
          this.coord.lat = this.cgps.lat
          this.coord.lng = this.cgps.lng
          this.coord.coords.update(this.coord)
        } else if (this.coords) {
          this.coord = this.coords.create(this.cgps.lat, this.cgps.lng)
          this.coord.coords = this.coords
        }
      } else if (this.coord) {
        this.coord.coords.remove(this.coord)
        this.coord = null
      }
    },
  },
  watch: {
    unit() {
      this.updateIcon()
    },
    color(nv, ov) {
      if (ov !== nv) {
        this.updateIcon()
      }
    },
    speed(nv, ov) {
      if ((ov && ov[1]) !== (nv && nv[1])) {
        this.updateIcon()
      }
    },
    '$store.state.selectedUnit': function(nv, ov) {
      if (nv === this.uid || ov === this.uid)
        this.updateIcon()
    },
    cgps(nv, ov) {
      if (nv.lat === ov.lat && nv.lng === ov.lng) return
      this.marker.setPosition(nv)
      this.updateCoord()
    },
    visible(nv, ov) {
      this.marker.setVisible(nv)
      this.updateCoord()
    },
    zIndex(nv, ov) {
      this.marker.setZIndex(nv)
    },
    coords(nv, ov) {
      if (this.coord) {
        this.coord.coords.remove(this.coord)
        this.coord = null
      }
      this.updateCoord()
    },
  },
  mounted() {
    this.google.maps.event.addListener(this.marker, 'click', async () => {
      this.$store.commit('selectPoi', null)
      try {
        await this.$router.push(`/u/${this.uid}/s`)
      } catch(e) {}
    })
    this.google.maps.event.addListener(this.marker, 'mouseover', () => {
      this.$store.commit('hoverUnitId', this.uid)
    })
    this.google.maps.event.addListener(this.marker, 'mouseout', () => {
      this.$store.commit('hoverUnitId', null)
    })
    this.updateIcon()
  },
  destroyed() {
    if (this.marker)
      this.marker.setMap(null)
    if (this.coord) {
      this.coord.coords.remove(this.coord)
      this.coord = null
    }
  },
}
</script>
